import { Horse } from './horse';
import { Person } from './person'
import { Payee } from './payee';
import { Signature } from './signature';
import { Statement } from './accounting/statement';
import { I_competition_entry } from './i_competition_entry.interface';
import { Competition_entry } from './competition_entry';
import { Additional_field_response } from './additional_field';

export class Horse_show_entry {
	id: string;
	horse_show_id: string;	
	entry_number: number;
	horse_show_number: number;
	horse_show_organizer_id: string;
	horse_id: string;	
	horse_name: string;	
	owner_person_id: string;	
	owner_first_name: string;	
	owner_last_name: string;	
	owner_full_name: string;	
	trainer_person_id: string;	
	trainer_first_name: string;	
	trainer_last_name: string;	
	trainer_full_name: string;	
	user_name: string;	
	user_email: string;	
	user_id: string;	
	created_date: Date;
	last_modified: Date;
	status: string;	
	submitted: boolean;
	submitted_date: Date;
	accepted: boolean;
	accepted_date: Date;
	accepted_by: string;	
	rejected: boolean;
	rejected_date: Date;
	rejected_by: string;	
	arrival_date: Date;
	stable_with: string;	
	stabling_requested: string;	
	comments: string;	
	emergency_contact_name: string;	
	emergency_contact_number: string;	
	guest_email: string;
	entry_type: number;
	barn_account: boolean;
	additional_fields: Additional_field_response[];
	payee_id: string;
	balance_due: boolean;
	
	//Additional objects loaded for one entry at atime
	rider_list: Person[];
	horse: Horse;
	horse_list: Horse[];
	owner: Person;
	owner_list: Person[];
	trainer: Person;
	trainer_list: Person[];
	coach: Person;
	parent_list: Person[];
	signature_list: Signature[];
	competition_entry_list: Competition_entry[];
	pending_competition_entry_list: I_competition_entry[];
	statement:Statement;
	payee: Payee;
	payer: Person;
	//Additional Optional Roles by Discipline
	//Driving
	groom: Person;
	navigator: Person;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}	